import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import { sync } from 'vuex-router-sync'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import VueTheMask from 'vue-the-mask'
import vueDebounce from 'vue-debounce'
import vClickOutside from 'v-click-outside'
import tinymce from 'vue-tinymce-editor'

Vue.component('tinymce', tinymce)


const VueUploadComponent = require('vue-upload-component')
Vue.component('file-upload', VueUploadComponent)


Vue.use(ElementUI)
Vue.use(VueTheMask)
Vue.use(vueDebounce)
Vue.use(vClickOutside)

sync(store, router)

Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
